import { render } from "./EmployeeUpdatePhoto.vue?vue&type=template&id=b3282740&scoped=true"
import script from "./EmployeeUpdatePhoto.vue?vue&type=script&lang=js"
export * from "./EmployeeUpdatePhoto.vue?vue&type=script&lang=js"

import "./EmployeeUpdatePhoto.vue?vue&type=style&index=0&id=b3282740&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3282740"]])

export default __exports__